































import { Vue, Component, Prop } from 'vue-property-decorator';

import ChevronRightSolid from '~/components/icons/ChevronRightSolid.vue';
import Dropdown from '~/components/partials/Dropdown.vue';
import LabelsPicker from "~/components/partials/LabelsPicker.vue";

type Value = string | number;

@Component({
  components: {
    LabelsPicker,
    ChevronRightSolid,
    Dropdown,
  },
})
export default class LabelsDropdown extends Vue {
  @Prop(String) model: 'route' | 'event' | 'destination';
  @Prop(String) label: '';
  @Prop({ type: [Array, Object, Number, String], default: null }) value: Value[] | Value | null;

  $refs: {
    dropdown: HTMLButtonElement;
    chevron: Vue;
  };

  /* Returns a width for the dropdown based on device's innerWidth */
  get dropdownWidth () {
    if (process.client) {
      return window.innerWidth < 768 ? 'w-full' : 'w-30';
    }
    return '';
  }

  /*
    This computed gives a hint to check if user has applied any filter in
    template. It will update dropdown style if yes.
  */
  get filterHasBeenApplied () {
    if (Array.isArray(this.value)) {
      return this.value.length > 0;
    }

    return false;
  }

  get nbSelected () : Number {
    if (Array.isArray(this.value)) {
      return this.value.length;
    }

    return 0;
  }
}
